module.exports = __webpack_public_path__ + "static/media/newsPoint01.84790e27.jpeg";